export default __webpack_public_path__ + "0981cd7abb5c0db3563d2d477d3cbe7d.png";